export default function html2canvas(el, opts, callback) {
  import('html2canvas').then(mod => {
    const func = mod.default
    func(el, opts).then(canvas => callback(canvas))
  })
}
